import React, { useEffect, useState } from 'react';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const ContainerBox = styled(Box)({
  position: 'relative',
  width: '100%',
  height: '100%',
  minHeight: '300px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

const StyledSlider = styled(ReactCompareSlider)({
  width: '100%',
  height: '100%',
  '& img': {
    maxHeight: 'calc(100vh - 200px)',
    objectFit: 'contain',
    backgroundColor: '#f0f0f0',
  },
});

const ImageCompare = ({ imageUrl, altImageUrl, alt = 'photo', minHeight = '80vh', minWidth = '400px' }) => {
  const [position, setPosition] = useState(50); // 0 = show original image fully
  const customStyle = {
    minHeight,
    minWidth,
  };

  useEffect(() => {
    setPosition(50);
  }, [altImageUrl]);

  if (!altImageUrl || !imageUrl) {
    return (
      <ContainerBox>
        <img
          alt="Full POD"
          src={imageUrl || altImageUrl}
          style={{
            border: 'solid 1px #888',
            maxWidth: 600,
            maxHeight: 'calc(100vh - 100px)',
            ...customStyle,
          }}
        />
      </ContainerBox>
    );
  }

  return (
    <ContainerBox>
      <StyledSlider
        itemOne={<ReactCompareSliderImage src={imageUrl} alt={`${alt}`} style={customStyle} />}
        itemTwo={<ReactCompareSliderImage src={altImageUrl} alt={`${alt} - alternative`} style={customStyle} />}
        position={position}
        onPositionChange={setPosition}
        transition="0.1s ease"
      />
    </ContainerBox>
  );
};

export default ImageCompare;
